import type { SVGProps } from 'react';

export function CarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 14a3 3 0 1 1-3 3l.005-.176A3 3 0 0 1 7 14m11 0a3 3 0 1 1-3 3l.005-.176A3 3 0 0 1 18 14M7 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2m11 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2M14.438 4a3 3 0 0 1 2.91 2.272L17.781 8H20a3 3 0 0 1 2.995 2.824L23 11v3.02l-.01.117a1 1 0 0 1-.286.575l-.107.091-.07.049-.076.042-.106.046-.017.005-.047.016-.108.025-.118.013-.08.002-.122-.012-.148-.033-.063-.022a1 1 0 0 1-.362-.24l-.08-.094a4 4 0 0 0-6.4 0 1 1 0 0 1-.8.4h-3a1 1 0 0 1-.8-.4 3.998 3.998 0 0 0-6.402.002.999.999 0 0 1-1.791-.456 1 1 0 0 1 .189-.742c.493-.66 1.11-1.2 1.804-1.602V9.01a1 1 0 0 1 .06-.35l.042-.1 2.004-4.007A1 1 0 0 1 7 4zM2 6a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m12.438 0H11v2h4.718l-.31-1.243a1 1 0 0 0-.97-.757M9 6H7.618L6.617 8H9z" />
    </svg>
  );
}
